import { Injectable } from '@angular/core';
import { DomService } from '@nano/common/dom';
import { ApiEndpoints, ApiResponse, ApiService } from '@nano/core/api';
import { NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FileTypes, FileUploaded } from './file';

@Injectable({ providedIn: 'root' })
export class FileService {
  constructor(
    private apiService: ApiService,
    private domService: DomService
  ) {}

  upload(nzUploadFile: NzUploadFile | NzUploadXHRArgs): Observable<FileUploaded> {
    const formData = new FormData();
    formData.set(nzUploadFile.name, nzUploadFile.file as string | Blob);
    return this.apiService.post<ApiResponse<FileUploaded[]>>(ApiEndpoints.attachments(), formData).pipe(map((apiResponse) => apiResponse.response[0]));
  }

  delete(attachmentId: string): Observable<ApiResponse> {
    return this.apiService.delete<ApiResponse<FileUploaded[]>>(ApiEndpoints.attachment(attachmentId));
  }

  download(attachmentId: string, name: string, mediaType: string): void {
    this.apiService.getBlob(ApiEndpoints.attachment(attachmentId), mediaType).subscribe((data) => {
      const link = this.domService.createFileDownloadLink(data, name);
      link.click();
    });
  }

  getDocumentFile(documentId: string): Observable<Blob> {
    return this.apiService.getBlob(ApiEndpoints.documentsFile(documentId), FileTypes.pdf.mediaType);
  }
}
